/**
 * Utility functions for file operations
 */

/**
 * Converts a 2D array of data to CSV format
 */
export const formatAsCsv = (data: string[][]) =>
  data.map((row) => row.map((cell) => `"${cell}"`).join(',')).join('\n');

/**
 * Downloads content as a CSV file
 */
export const downloadCsv = ({
  csvData,
  filename = 'table.csv'
}: {
  csvData: string;
  filename?: string;
}): void => {
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } finally {
    URL.revokeObjectURL(url);
  }
};
